import { useResolvedFlags } from "@amtana/feature-flag-client";
import { useMyOrganizations } from "@amtana/organization-client";

// ADR-006 §7: the platform app's own flags source, installed with
// `withFlagsSource` in feature-flag.web.ts. Composes the active organization
// id (from organization's own client, the browser half's job: a client reads
// only its own contract) with the resolveAll read; switching organization
// reloads the page, so this simply runs again from scratch with the new one.

export function useFlagValuesSource(): Readonly<Record<string, boolean>> | undefined {
  // Signed-out pages (sign-in, sign-up) render too: a refused read means no flags, not a crash.
  const organizations = useMyOrganizations({ optional: true });
  const organizationId = organizations.data?.activeOrganizationId ?? undefined;
  const resolved = useResolvedFlags(organizationId);
  return resolved.data?.flags;
}
